export const privacyPolicyData = [
  {
    id: 1,
    title: 'Introduction',
    content: [
      `Intelligra Solutions Limited (“Intelligra”, “we”, “our”, or “us”) is committed to protecting the privacy and personal data of individuals who use our website, platforms, and services (“Services”).`,
      `This Privacy Policy explains what data we collect, why we collect it, how we use it, how we store it, and your rights regarding your personal data.`,
      `By using our Services, you acknowledge that you have read and understood this Privacy Policy.`,
    ],
  },
  {
    id: 2,
    title: 'Scope of This Policy',
    content: [
      {
        type: 'list',
        items: [
          'Visitors to our website',
          'Customers applying for or using device loan services',
          'Users interacting with our platforms, applications, or communications',
        ],
      },
      `This Privacy Policy does not apply to third-party websites or services linked from our platforms.`,
    ],
  },
  {
    id: 3,
    title: 'Personal Data We Collect',
    content: [
      `We collect personal data that is necessary to deliver device financing, comply with legal obligations, and manage risk.`,
      {
        type: 'subsection',
        title: 'Information You Provide Directly',
        items: [
          'Full name',
          'Phone number',
          'Email address',
          'Residential or contact address',
          'Government-issued identity documents',
          'Additional onboarding or verification data',
        ],
      },
      {
        type: 'subsection',
        title: 'Automatically Collected Information',
        items: [
          'Device identifiers and usage data',
          'IP address, browser type, and access logs',
          'Website or platform interaction data',
        ],
      },
      {
        type: 'subsection',
        title: 'Third-Party Information',
        items: [
          'Identity verification results',
          'Credit or risk-related data',
          'Information from network operators or credit bureaus',
        ],
      },
    ],
  },
  {
    id: 4,
    title: 'Purpose of Data Processing',
    content: [
      {
        type: 'list',
        items: [
          'Customer identification and verification (KYC)',
          'Credit profiling and risk assessment',
          'Device loan approval, management, and recovery',
          'Fraud prevention and security monitoring',
          'Regulatory and AML compliance',
          'Customer communication and support',
          'Internal analytics and service improvement',
        ],
      },
    ],
  },
  {
    id: 5,
    title: 'Legal Basis for Processing',
    content: [
      {
        type: 'list',
        items: [
          'Your explicit consent',
          'Performance of a contract',
          'Compliance with legal obligations',
          'Legitimate business interests',
        ],
      },
    ],
  },
  {
    id: 6,
    title: 'Data Sharing and Disclosure',
    content: [
      {
        type: 'list',
        items: [
          'Financial institutions and lending partners',
          'Mobile network operators',
          'Technology and device partners',
          'Fraud-prevention and identity verification providers',
          'Credit bureaus and regulators',
        ],
      },
      `We do not sell personal data to unauthorized third parties.`,
    ],
  },
  {
    id: 7,
    title: 'Data Storage and Security',
    content: [
      {
        type: 'list',
        items: [
          'Encrypted storage and secure servers',
          'Role-based access controls',
          'Monitoring and logging',
          'Periodic security reviews',
        ],
      },
    ],
  },
  {
    id: 8,
    title: 'Data Retention',
    content: [
      `Personal data is retained only as long as necessary and securely deleted or anonymized when no longer required.`,
    ],
  },
  {
    id: 9,
    title: 'Your Rights',
    content: [
      {
        type: 'list',
        items: [
          'Access your personal data',
          'Correct inaccurate or incomplete data',
          'Request deletion where legally permitted',
          'Withdraw consent',
          'Object to processing',
          'Request data portability',
        ],
      },
    ],
  },
  {
    id: 10,
    title: 'Communications',
    content: [
      {
        type: 'list',
        items: ['Phone calls', 'SMS', 'Email', 'Platform notifications'],
      },
    ],
  },
  {
    id: 11,
    title: 'Cookies and Tracking Technologies',
    content: [
      `Cookies may be used to improve functionality, analyze traffic, and enhance user experience.`,
    ],
  },
  {
    id: 12,
    title: 'Cross-Border Data Transfers',
    content: [
      `Where data is transferred internationally, appropriate safeguards are applied.`,
    ],
  },
  {
    id: 13,
    title: 'Changes to This Privacy Policy',
    content: [
      `Updates will be published on our website. Continued use of our services constitutes acceptance.`,
    ],
  },
  {
    id: 14,
    title: 'Contact Us',
    content: [
      `Intelligra Solutions Limited`,
      `Email: info@intelligra.io`,
      `Address: 15b, Alh Kofoworola Street, Off Awolowo Way, Ikeja, Lagos, Nigeria`,
    ],
  },
];



export const termsAndConditionsData = [
  {
    id: 1,
    title: 'Introduction',
    content: [
      `These Terms and Conditions (“Terms”) govern the use of the website, mobile platforms, products, and services (“Services”) provided by Intelligra Solutions Limited (“Intelligra”, “we”, “our”, or “us”).`,
      `By accessing our website, applying for a device loan, or using any of our Services, you confirm that you have read, understood, and agreed to be bound by these Terms.`,
      `If you do not agree with these Terms, do not use our Services.`,
    ],
  },
  {
    id: 2,
    title: 'Eligibility',
    content: [
      {
        type: 'list',
        items: [
          'Be at least 18 years old',
          'Provide accurate, complete, and verifiable information',
          'Possess a valid government-issued identity document',
          'Have a valid phone number and email address',
          'Meet our internal credit and risk assessment criteria',
        ],
      },
      `We reserve the right to decline or terminate access to Services at our sole discretion.`,
    ],
  },
  {
    id: 3,
    title: 'Information We Collect',
    content: [
      `For the purpose of customer profiling, credit assessment, and device loan processing, we may collect and process the following information:`,
      {
        type: 'list',
        items: [
          'Phone number',
          'Email address',
          'Residential or contact address',
          'Government-issued identity documents',
          'Device usage and repayment-related data (where applicable)',
        ],
      },
      `You confirm that all information provided is truthful, current, and belongs to you.`,
      `Providing false or misleading information may result in immediate disqualification or termination of services.`,
    ],
  },
  {
    id: 4,
    title: 'Purpose of Data Collection',
    content: [
      {
        type: 'list',
        items: [
          'Customer identification and verification',
          'Credit profiling and risk assessment',
          'Device loan approval and management',
          'Fraud prevention and regulatory compliance',
          'Communication regarding your account and obligations',
        ],
      },
      `By using our Services, you expressly consent to the collection, storage, and processing of your data for these purposes.`,
    ],
  },
  {
    id: 5,
    title: 'Identity Verification',
    content: [
      `You authorize Intelligra to:`,
      {
        type: 'list',
        items: [
          'Verify your identity using third-party verification services',
          'Share your information with financial institutions, device manufacturers, mobile network operators, and credit bureaus where required',
        ],
      },
      `This authorization is necessary for device financing and loan administration.`,
    ],
  },
  {
    id: 6,
    title: 'Device Loan Terms',
    content: [
      {
        type: 'list',
        items: [
          'Ownership of the device may remain conditional upon full repayment',
          'The device may include technical controls to enforce repayment terms',
          'Failure to meet repayment obligations may result in restricted device functionality, service suspension, or recovery actions',
        ],
      },
      `Loan terms, repayment schedules, and penalties (if any) will be communicated separately and form part of your binding agreement.`,
    ],
  },
  {
    id: 7,
    title: 'User Responsibilities',
    content: [
      `You agree to:`,
      {
        type: 'list',
        items: [
          'Use financed devices lawfully and responsibly',
          'Maintain active communication channels with Intelligra',
          'Repay loan obligations as agreed',
          'Notify us promptly of changes to your contact or personal information',
        ],
      },
      `You must not attempt to tamper with, bypass, or disable any device control mechanisms.`,
    ],
  },
  {
    id: 8,
    title: 'Data Protection and Privacy',
    content: [
      `We are committed to protecting your personal data in line with applicable data protection laws, including the Nigeria Data Protection Regulation (NDPR).`,
      {
        type: 'list',
        items: [
          'Be stored securely',
          'Be accessed only by authorized personnel',
          'Not be sold to unauthorized third parties',
        ],
      },
      `For full details, please refer to our Privacy Policy, which forms part of these Terms.`,
    ],
  },
  {
    id: 9,
    title: 'Communications',
    content: [
      {
        type: 'list',
        items: [
          'Phone calls',
          'SMS',
          'Email',
          'In-app or platform notifications',
        ],
      },
      `These communications may relate to loan status, repayments, reminders, or service updates.`,
    ],
  },
  {
    id: 10,
    title: 'Limitation of Liability',
    content: [
      {
        type: 'list',
        items: [
          'Intelligra shall not be liable for indirect, incidental, or consequential losses',
          'We do not guarantee loan approval or uninterrupted service availability',
          'Services are provided on an “as-is” and “as-available” basis',
        ],
      },
    ],
  },
  {
    id: 11,
    title: 'Termination',
    content: [
      `We may suspend or terminate your access to Services if:`,
      {
        type: 'list',
        items: [
          'You breach these Terms',
          'You provide false information',
          'You default on repayment obligations',
          'Required by law or regulation',
        ],
      },
      `Termination does not extinguish outstanding financial obligations.`,
    ],
  },
  {
    id: 12,
    title: 'Amendments',
    content: [
      `We reserve the right to update these Terms at any time.`,
      `Updated versions will be posted on our website, and continued use of our Services constitutes acceptance of the revised Terms.`,
    ],
  },
  {
    id: 13,
    title: 'Contact Information',
    content: [
      `Intelligra Solutions Limited`,
      `Email: info@intelligra.io`,
      `Address: 15b, Alh Kofoworola Street, Off Awolowo Way, Ikeja, Lagos, Nigeria`,
    ],
  },
];

